/*
  how it works
*/
/**
 * Desktop/Mobile How It Works script
 */

/************************************************
		SELECT HIW DESKTOP MODULES
			even the height
*************************************************/
$("[class^=desk_hiw_steps-]").each(function() {

	//-- get the HIW wrapperzz blocks (commonly 3)
	var blocks = $(this).find(".bullets .block-wrapper");

	//-- initialize max height value
	var h_max = 0;

	//-- go though each found blocks
	blocks.each(function() {
		//-- get height of current block
		var h = $(this).height();

		//-- if it's higher than the one stored in h_max, save it in h_max
		h_max = h > h_max ? h : h_max;
	});

	blocks.css("height", h_max+"px");
});

/************************************************
		SPECIAL CASE: NO HIW WHEN USER HAS RECORDS
*************************************************/
if (PAGE_CODE === 'wrp' || PAGE_CODE === 'mbp') {
	var benefit_table = $('[class^=desk_simple_table]');

	if (benefit_table.length > 0) {
		benefit_table = benefit_table.eq(0);

		var rows = benefit_table.find('.table_row');

		if (rows.length > 0) {
			$('[class*=desk_hiw_steps], [class*=mob_hiw_v_list]').remove();
		}
	}
}
